import React, { Component } from "react";
import { ReelObject } from "./reelObject";
import { configGame, constant } from "./../data/config";


interface IProps {
    [x: string]: any;
}
interface IState {
    [x: string]: any;

}


class Cheat extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected ImgData: any;

    protected hor_reel_Count: number;
    protected hor_row_Count: number;
    protected reel_Count: number;
    protected row_Count: number;
    protected SCATTER_ID: number;
    protected WILD_ID: number;
    protected HorizontalData: any;
    protected MainReelData: any;
    protected forceSelected = false;
    protected freegameSelected = false;
    protected seedSelected = false;
    protected seed1Selected = false;
    protected seed2Selected = false;
    protected seed3Selected = false;
    protected forceSeedReelHeight: any;

    constructor(props: IProps) {
        super(props);
        this.SCATTER_ID = 11;
        this.WILD_ID = 10;
        this.app = props.app;
        this.hor_reel_Count = 1;
        this.hor_row_Count = 4;
        this.reel_Count = 6;
        this.row_Count = 6;
        this.forceSeedReelHeight = [];
        this.state = {
            toggle: false,
            forcechecked: false,
            seedchecked: false,
            randomWild: false,
            seed1Checked: false,
            seed2Checked: false,
            seed3Checked: false,

        };


        this.HorizontalData = [];
        this.MainReelData = [];

        for (let i = 0; i < this.hor_row_Count; i++) {
            let symbolObj = { reel: 0, row: i, symbol: -1 };
            this.HorizontalData.push(symbolObj)
        }

        for (let i = 0; i < this.reel_Count; i++) {
            for (let j = 0; j < this.row_Count; j++) {
                let symbolObj = { reel: i, row: j, symbol: -1 }
                this.MainReelData.push(symbolObj)
            }
        }
        this.ImgData = [
            {
                "id": 0,
                "img": "./LD/assets/symbol/static/lv_1.png"
            },
            {
                "id": 1,
                "img": "./LD/assets/symbol/static/lv_2.png"
            },
            {
                "id": 2,
                "img": "./LD/assets/symbol/static/lv_3.png"
            },
            {
                "id": 3,
                "img": "./LD/assets/symbol/static/lv_4.png"
            },
            {
                "id": 4,
                "img": "./LD/assets/symbol/static/lv_5.png"
            },
            {
                "id": 5,
                "img": "./LD/assets/symbol/static/hv_1.png"
            },
            {
                "id": 6,
                "img": "./LD/assets/symbol/static/hv_2.png"
            },
            {
                "id": 7,
                "img": "./LD/assets/symbol/static/hv_3.png"
            },
            {
                "id": 8,
                "img": "./LD/assets/symbol/static/hv_4.png"
            },
            {
                "id": 9,
                "img": "./LD/assets/symbol/static/hv_5.png"
            },
            {
                "id": 10,
                "img": "./LD/assets/symbol/static/wild_1x1.png"
            },
            {
                "id": 11,
                "img": "./LD/assets/symbol/static/bonus.png"
            },

        ];

    }

    checkboxHandleFG(e: any) {
        this.freegameSelected = e.currentTarget.checked;
        this.setState((prevState) => {
            return {
                ...prevState,
                freegamechecked: this.freegameSelected,
            }
        })
        this.handleCase();
    }


    checkboxHandleSeed1(e: any) {
        this.seed1Selected = e.currentTarget.checked;
        this.setState((prevState) => {
            return {
                ...prevState,
                seed1Checked: this.seed1Selected,
            }
        })
        this.handleCase();
    }
    checkboxHandleSeed2(e: any) {
        this.seed2Selected = e.currentTarget.checked;
        this.setState((prevState) => {
            return {
                ...prevState,
                seed2Checked: this.seed2Selected,
            }
        })
        this.handleCase();
    }
    checkboxHandleSeed3(e: any) {
        this.seed3Selected = e.currentTarget.checked;
        this.setState((prevState) => {
            return {
                ...prevState,
                seed3Checked: this.seed3Selected,
            }
        })
        this.handleCase();
    }

    cleanAllCheat() {
        constant.configGame.cheatModifiedRequest = ''
    }
    clearCheat(e: any) {
        constant.configGame.cheatModifiedRequest = ''
        this.setState(() => ({
            forcechecked: false,
            freegamechecked: false,
            seedchecked: false,
            randomWildCheked: false,
            seed1Checked: false,
            seed2Checked: false,
            seed3Checked: false
        }));

        this.seedSelected = false;
        this.forceSelected = false;
        this.freegameSelected = false;
        this.seed1Selected = false;
        this.seed2Selected = false;
        this.seed3Selected = false;
        this.HorizontalData = [];
        this.MainReelData = [];

        for (let i = 0; i < this.hor_row_Count; i++) {
            let symbolObj = { reel: 0, row: i, symbol: -1 };
            this.HorizontalData.push(symbolObj)
        }

        for (let i = 0; i < this.reel_Count; i++) {
            for (let j = 0; j < this.row_Count; j++) {
                let symbolObj = { reel: i, row: j, symbol: -1 }
                this.MainReelData.push(symbolObj)
            }
        }
        this.forceSeedReelHeight = [];
        (document.getElementById("textSeed") as any).value = "";
        this.forceUpdate();
    }

    updateCheat() {
        this.handleCase();
    }

    checkboxSeedHandle(e: any) {
        this.seedSelected = e.currentTarget.checked;
        this.setState((prevState) => {
            return {
                ...prevState,
                seedchecked: this.seedSelected,
            }
        })
        this.handleCase();
    }

    checkboxHandle(e: any) {
        this.forceSelected = e.currentTarget.checked;
        this.setState((prevState) => {
            return {
                ...prevState,
                forcechecked: this.forceSelected,
            }
        })
        constant.configGame.cheatModifiedRequest = ''
        this.handleCase();

    }
    handleCase() {
        if (this.forceSelected) {
            if (this.freegameSelected) {
                this.implementCheat(true, false)
            } else if (this.seedSelected && (document.getElementById("textSeed") as any).value != "") {

                this.implementCheat(false, true)
            } else {

                this.implementCheat(false, false)
            }

        } else {
            this.cleanAllCheat();
        }
    }
    createCheat(horizontalReel: any, FRH: any, reelContents: any) {
        let bonus = 0;
        let seed = 0;
        let freegame = 0;

        if (this.seed1Selected) {
            bonus = 1;
            seed = 1;
        }
        if (this.seed2Selected) {
            bonus = 1;
            seed = 2;
        }
        if (this.seed3Selected) {
            bonus = 1;
            seed = 3;
        }
        if (this.freegameSelected) {
            freegame = 1;
        }

        constant.configGame.cheatModifiedRequest = JSON.stringify(
            "&forceFeatures=0&reelContents=" + reelContents + "&freeSpins=0" + freegame + "&bonus=" + bonus + "&seed=" + seed + "&hash=-1716375052"

        );

    }
    onlyFreegame() {
        let forceReelHeights = "";
        let reelContents = "";
        let nonNegativeCountOnReel_1 = -1;
        let nonNegativeCountOnReel_2 = -1;
        let nonNegativeCountOnReel_3 = -1;
        let nonNegativeCountOnReel_4 = -1;
        let nonNegativeCountOnReel_5 = -1;
        let nonNegativeCountOnReel_6 = -1;
        let count = 0;
        for (let i = 0; i < this.MainReelData.length; i++) {
            if (this.MainReelData[i].symbol > -1) {
                count++;
            }
            if (i == 0) {
                reelContents = this.MainReelData[i].symbol;
            } else {
                if (i == 7 || i == 14 || i == 18 || i == 21 || i == 28) {

                    if (count == 1 && this.MainReelData[i].symbol == -1) {
                        count++;

                        reelContents = reelContents + "," + this.SCATTER_ID;

                    } else {

                        reelContents = reelContents + "," + this.SCATTER_ID;
                    }
                } else {
                    if (count == 1 && this.MainReelData[i].symbol == -1) {
                        count++;

                        reelContents = reelContents + "," + this.MainReelData[i - 1].symbol;

                    } else {

                        reelContents = reelContents + "," + this.MainReelData[i].symbol;
                    }
                }

            }
        }


        forceReelHeights = nonNegativeCountOnReel_1 + ","
            + nonNegativeCountOnReel_2 + ","
            + nonNegativeCountOnReel_3 + ","
            + nonNegativeCountOnReel_4 + ","
            + nonNegativeCountOnReel_5 + ","
            + nonNegativeCountOnReel_6

        let horizontalReel = this.HorizontalData[0].symbol + "," + this.HorizontalData[1].symbol + ","
            + this.HorizontalData[2].symbol + "," + this.HorizontalData[3].symbol;

        this.createCheat(horizontalReel, forceReelHeights, reelContents);
    }
    onlySeed() {
        let textSeed: any = (document.getElementById("textSeed") as any).value;
        var match = textSeed.split(',');
        this.forceSeedReelHeight = [];
        for (let a in match) {
            if (Number(match[a]) != NaN && match[a] != "") {
                if (match[a] < this.ImgData.length) {
                    this.forceSeedReelHeight.push(Number(match[a]));
                } else {
                    this.forceSeedReelHeight.push(-1);
                }
            } else {
                this.forceSeedReelHeight.push(-1);
            }
        }
        if (this.forceSeedReelHeight.length > 0) {
            let FRH = "";
            if (this.forceSeedReelHeight[0]) {
                FRH = FRH + this.forceSeedReelHeight[0] + ","
            } if (this.forceSeedReelHeight[1]) {
                FRH = FRH + this.forceSeedReelHeight[1] + ","
            } if (this.forceSeedReelHeight[2]) {
                FRH = FRH + this.forceSeedReelHeight[2] + ","
            } if (this.forceSeedReelHeight[3]) {
                FRH = FRH + this.forceSeedReelHeight[3] + ","
            } if (this.forceSeedReelHeight[4]) {
                FRH = FRH + this.forceSeedReelHeight[4] + ","
            } if (this.forceSeedReelHeight[5]) {
                FRH = FRH + this.forceSeedReelHeight[5] + ","
            } else {
                FRH = FRH + "-1" + ","
            }

            let reelContents = "";
            let count = 0;
            for (let i = 0; i < this.MainReelData.length; i++) {
                if (this.MainReelData[i].symbol > -1) {
                    count++;
                }
                if (i == 0) {
                    reelContents = this.MainReelData[i].symbol;
                } else {
                    if (count == 1 && this.MainReelData[i].symbol == -1) {
                        count++;
                        reelContents = reelContents + "," + this.MainReelData[i - 1].symbol;
                    } else {
                        reelContents = reelContents + "," + this.MainReelData[i].symbol;
                    }
                }
            }
            let horizontalReel = this.HorizontalData[0].symbol + "," + this.HorizontalData[1].symbol + ","
                + this.HorizontalData[2].symbol + "," + this.HorizontalData[3].symbol;
            this.createCheat(horizontalReel, FRH, reelContents)
        }
    }
    onlyGrig() {
        let forceReelHeights = "";
        let reelContents = "";
        let nonNegativeCountOnReel_1 = -1;
        let nonNegativeCountOnReel_2 = -1;
        let nonNegativeCountOnReel_3 = -1;
        let nonNegativeCountOnReel_4 = -1;
        let nonNegativeCountOnReel_5 = -1;
        let nonNegativeCountOnReel_6 = -1;
        let count = 0;
        for (let i = 0; i < this.MainReelData.length; i++) {
            if (this.MainReelData[i].symbol > -1) {
                count++;
            }
            if (i == 0) {
                reelContents = this.MainReelData[i].symbol;
            } else {
                if (count == 1 && this.MainReelData[i].symbol == -1) {
                    reelContents = reelContents + ",-1";

                } else {
                    reelContents = reelContents + "," + this.MainReelData[i].symbol;
                }
            }
        }

        forceReelHeights = nonNegativeCountOnReel_1 + ","
            + nonNegativeCountOnReel_2 + ","
            + nonNegativeCountOnReel_3 + ","
            + nonNegativeCountOnReel_4 + ","
            + nonNegativeCountOnReel_5 + ","
            + nonNegativeCountOnReel_6

        let horizontalReel = this.HorizontalData[0].symbol + "," + this.HorizontalData[1].symbol + ","
            + this.HorizontalData[2].symbol + "," + this.HorizontalData[3].symbol;

        this.createCheat(horizontalReel, forceReelHeights, reelContents);

    }
    implementCheat(alreadyFg: boolean, alreadySeed: boolean) {

        if (alreadyFg) {

            this.onlyFreegame();
        } else if (alreadySeed) {

            this.onlySeed();
        } else {

            this.onlyGrig();

        }
    }



    makeDigitToVisible(e: any) {

        let handleKeys = ['1', "2", "3", "4", "5", "6", "7", "8", "9", "0", ","];
        if (handleKeys.indexOf(e.key) > -1) {

            //return true;
        } else {
            e.currentTarget.value = "";
        }
        this.handleCase();

    }

    render() {

        var propsToSent = {
            callback: null,
            imageData: this.ImgData,
            HorizontalData: this.HorizontalData,
            MainReelData: this.MainReelData,
            forcechecked: this.forceSelected,
            updateCheat: this.updateCheat,
            scope: this
        }

        return (
            <>
                <div className="main-container">
                    <div className={!this.state.toggle ? "sub-container-toggle" : "sub-container"} >
                        <span id="toggle" onClick={() => { this.setState({ toggle: !this.state.toggle }) }}>{!this.state.toggle ? <span style={{ color: "white", fontSize: "25px", marginBottom: "10px" }}>&#60;</span> : <span >&#10006; </span>}</span>
                        <div className="sub-checkboxes">
                            <label className="container" >
                                <input type="checkbox" className="option-input checkbox" checked={this.forceSelected} onClick={this.checkboxHandle.bind(this)}></input>
                                <span className="checkmark">  </span>   Force
                            </label>
                            <label className="container">
                                <input type="checkbox" className="option-input checkbox" checked={this.freegameSelected} onClick={this.checkboxHandleFG.bind(this)}></input>
                                <span className="checkmark"> </span>  Freespins
                            </label>
                            <label className="container">
                                <input type="checkbox" className="option-input checkbox" checked={this.seed1Selected} onClick={this.checkboxHandleSeed1.bind(this)} ></input>
                                <span className="checkmark"> </span>  Random Wilds
                            </label>
                            <label className="container">
                                <input type="checkbox" className="option-input checkbox" checked={this.seed2Selected} onClick={this.checkboxHandleSeed2.bind(this)} ></input>
                                <span className="checkmark"> </span>  Giant Wild 2x2
                            </label>
                            <label className="container">
                                <input type="checkbox" className="option-input checkbox" checked={this.seed3Selected} onClick={this.checkboxHandleSeed3.bind(this)} ></input>
                                <span className="checkmark"> </span>  Giant Wild 3x3
                            </label>
                        </div>
                        <div className="Clear-box">
                            <span id="Clear" onClick={this.clearCheat.bind(this)}>
                                Clear
                            </span>
                        </div>

                        <div className="multiple-row-change">
                            <div className="multiple-row">
                                {
                                    this.MainReelData.map((data: any, index: number) => <div className="multiple-row-div"  >
                                        <ReelObject {...propsToSent} type={"NORMAL_REEL"} index={index}></ReelObject>
                                    </div>)
                                }
                            </div>
                        </div>
                        <div className="sub-checkboxes">
                            <label className="container">
                                <input type="checkbox" checked={this.seedSelected} onClick={this.checkboxSeedHandle.bind(this)}></input>
                                <span className="checkmark" >  </span > Seed
                            </label>
                            <label className="container">
                                <input type="checkbox"></input>
                                <span className="checkmark"> </span>  Test
                            </label>
                        </div>
                        <div className="sub-inputboxes">

                            <input type="input" id="textSeed" onKeyUp={this.makeDigitToVisible.bind(this)} ></input>
                        </div>

                    </div>
                </div>

            </>

        )
    }
}
export default Cheat
